import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-msg",
  "use": "icon-msg-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-msg\"><defs><style type=\"text/css\"></style></defs><path d=\"M920 145.6v600H369.1l-11.7 11.7-104.5 104.5-104.5-104.5-11.7-11.7H104v-600h816m40-40H64v680h56.1l132.8 132.8 132.8-132.8H960v-680zM792 284.7H232v40h560v-40z m0 138H232v40h560v-40zM574.5 560.6H232v40h342.5v-40z\" fill=\"\" p-id=\"6767\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol